import Select from "@/components/ui/select";
import {PropertiesCombobox} from "@/src/modules/properties/components/properties-combobox2";
import type {Property} from "@/src/modules/properties/types";

import {DASHBOARD_PERIOD_OPTIONS} from "../lib";
import type {DashboardOverviewFilters, DashboardPeriodKey} from "../types";

type DashboardFiltersProps = {
  filters: DashboardOverviewFilters;
  selectedProperties: Property[];
  onPeriodChange: (period: DashboardPeriodKey) => void;
  onPropertiesChange: (properties: Property[]) => void;
};

export function DashboardFilters({
  filters,
  selectedProperties,
  onPeriodChange,
  onPropertiesChange,
}: DashboardFiltersProps) {
  return (
    <div className="bg-card flex flex-col gap-3 rounded-xl border p-3 md:flex-row md:items-center">
      <div className="w-full md:w-48 md:shrink-0">
        <Select
          value={filters.period}
          onChange={(v) => onPeriodChange(v as DashboardPeriodKey)}
          placeholder="Select period"
          options={DASHBOARD_PERIOD_OPTIONS.map((o) => ({
            value: o.value,
            label: o.label,
          }))}
        />
      </div>

      <div className="min-w-0 w-full md:flex-1">
        <PropertiesCombobox
          multiple
          value={selectedProperties}
          onChange={(value) =>
            onPropertiesChange(Array.isArray(value) ? value : value ? [value] : [])
          }
          placeholder="All properties (filter activity)"
          shouldRenderSelection
        />
      </div>
    </div>
  );
}
